/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */


const scrollTo = (id) => {
  const el = document.querySelector(id)
  if (el) return window.scrollTo({top: el.offsetTop - 60, left: 0, behavior: 'smooth'});
  return false
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Your existing code for handling the hash and scrolling
  const { hash } = location;
  if (hash) {
    console.log(`Found hash in the URL, scrolling to ${hash}`); // Log the hash-based scrolling action
    window.setTimeout(() => scrollTo(hash), 5);
  }

   // Route change event for Analytics
  const routeChangeEvent = {
    event: 'gatsby-route-change',
    path: location.pathname,
    referrer: prevLocation ? prevLocation.pathname : null
  }
  window.dataLayer = window.dataLayer || [];
  console.log('Pushing a new route change to dataLayer:', routeChangeEvent); // Log the route change event
  window.dataLayer.push(routeChangeEvent); // Push the event to the data layer
};
